export const viewPages = {
  DASHBOARD: "Dashboard",
  SEARCH: "Search",
  SCOUTING: "Scouting",
  KPI: "Kpi",
  SIGN: "Sign In",
}
